export default "__VITE_ASSET__BJwwrDqR__"